// @ts-nocheck
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";

export const useInvoiceRmaLines = () => {
    return useAppSelector(state => state.store.pages.returnRequest.invoiceRmaLines);
};
